import { render, staticRenderFns } from "./HealthAndIndiscipline.vue?vue&type=template&id=2ebeff7c&"
import script from "./HealthAndIndiscipline.vue?vue&type=script&lang=js&"
export * from "./HealthAndIndiscipline.vue?vue&type=script&lang=js&"
import style0 from "./HealthAndIndiscipline.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VList,VListItemGroup,VTextarea})
